@if ((authService.isAuthenticated$ | async) === false) {
  <lib-landing (signInClick)="signInClicked()" [landingImageUrl]="landingImageURL"></lib-landing>
  @if (loginError$ | async) {}
}
@if (userLoggedIn$ | async) {
  @if (getUserNotificationCounts$ | async) {}
  @if (notificationAction$ | async) {}
  @if (refreshNotificationsGrid$ | async) {}
  @if (getUserNotifications$ | async) {}
  @if (signalRNotifyProgress$ | async) {}
  @if (signalRUserNotifications$ | async) {}
  @if (getMarkingAllAsRead$ | async) {}
  @if (sessionTimedOut$ | async) {}
  @if (countDownTimer$ | async) {}

  <div class="app-container">
    @if ((userId$ | async) && (userInfo$ | async)) {}
    <lib-common-mat-navbar
      #commonNavbar
      [displaySlideToggleTheme]="false"
      [initialTheme]="logoTypeTheme"
      [logotypeClass]="logoTypeThemeClass"
      [isAuthenticated]="(authService.isAuthenticated$ | async) || false"
      (raLogoClick)="goToHome()"
      (goToHomeClick)="goToHome()"
      (menuItemClick)="menuItemClick($event)"
      [enableUserActionsSideNav]="true"
      [navItems]="(navItems$ | async) || []"
      [enableUserProfile]="true"
      [accountMenu]="userInfo"
      [bannerItems]="bannerItems"
      (logoutClick)="logoutClicked()"
      [enableNotificationsSideNav]="true"
      [notifications]="(getNotifications$ | async)!"
      [notificationService$]="notificationService$"
      [totalNotificationsCount]="getTotalNotificationsCount$ | async"
      [notificationsInProgress$]="notificationsInProgress$"
      [refreshGrid$]="refreshNotifications$"
      [unreadNotificationsCount]="(getUnreadNotificationsCount$ | async)!"
      (notificationAction)="notificationAction($event)"
      (notificationCustomActionClick)="notificationCustomActionClicked($event)"
    >
      <div class="app-content-container">
        <div class="main-container">
          @if (breadcrumb$ | async; as breadcrumb) {
            <ra-fthub-breadcrumb
              class="common-admin-breadcrumb"
              id="common-admin-breadcrumb"
              [title]="breadcrumb.title"
              [items]="breadcrumb.items"
              [autoHideTitle]="true"
              [isReadOnly]="breadcrumb.items.length === 0"
              (itemClicked)="onBreadcrumbClicked($event)"
            >
            </ra-fthub-breadcrumb>
          }
          <router-outlet></router-outlet>
        </div>
      </div>
    </lib-common-mat-navbar>
  </div>
}

@if (isLoading$ | async) {
  <app-spinner></app-spinner>
}
<app-snackbar></app-snackbar>
